/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unarchivedonemessage2Inputs */



/**
* | output |
* | --- |
* | "The contact is back on the main list" |
*
* @param {Unarchivedonemessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const unarchivedonemessage2 = /** @type {((inputs?: Unarchivedonemessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unarchivedonemessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The contact is back on the main list")
	if (locale === "es") return /** @type {LocalizedString} */ ("El contacto está de vuelta en la lista principal")
	return /** @type {LocalizedString} */ ("Контакт возвращен на главную")
});
export { unarchivedonemessage2 as "unarchiveDoneMessage" }